var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['section', {'bottom-separator': _vm.bottomSeparator}, {'remove-bottom-padding': !_vm.hasBottomPadding}]},[(_vm.title)?_c('span',{staticClass:"title ri-bold-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }